import styled from "styled-components";
import breakpoints from "../../../styles/breakpoints";
import { colors, fonts } from "../../../styles/variables";

export const ContentContainer = styled.div<{ isWineDetailsPage: boolean }>`
  padding: ${(props) => (props.isWineDetailsPage ? "40px 80px" : "32px 15px")};
  background-color: ${colors.peach};
  min-height: 300px;

  ${breakpoints.smDown} {
    ${(props) => props.isWineDetailsPage && "padding: 32px 15px"};
  }
`;

export const Header = styled.h2`
  font-size: 35px;
  line-height: 0.9;
  color: ${colors.black};
  font-family: ${fonts.fontInterstateUltraBlack};
  text-transform: uppercase;
  margin-bottom: 32px;
  word-break: break-word;
`;

export const BadgeContainer = styled.div`
  display: flex;
  width: 100%;
  flex-flow: row wrap;
`;

export const BadgeWrapper = styled.div<{ isMobile: boolean }>`
  width: ${(props) => (props.isMobile ? "33.333%" : "25%")};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  flex-direction: column;
  margin-bottom: 30px;
`;
